import type { Project } from "../../types/project";

interface ProjectCardProps {
  project: Project;
}

function ProjectCard({ project }: ProjectCardProps) {
  return (
    <article className="project" tabIndex={0}>
      <div className="project-top">
        <div>
          <h3>{project.title}</h3>
        </div>
        <span className="status">{project.status}</span>
      </div>
      <p className="problem">{project.problem}</p>
      <p className="decision">{project.decision}</p>
      <div className="callouts">
        {project.callouts.map((callout) => (
          <div className="callout" key={callout.label}>
            <span className="k">{callout.label}:</span>
            {callout.value}
          </div>
        ))}
      </div>
      {(project.siteUrl || project.sourceUrl) && (
        <div className="project-links">
          {project.siteUrl && (
            <a
              className="btn sm ghost"
              href={project.siteUrl}
              target="_blank"
              rel="noreferrer"
            >
              View site
            </a>
          )}
          {project.sourceUrl && (
            <a
              className="btn sm ghost"
              href={project.sourceUrl}
              target="_blank"
              rel="noreferrer"
            >
              Source
            </a>
          )}
        </div>
      )}
    </article>
  );
}

export default ProjectCard;
